import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CLEAR_SYS_GUARD_ALERT_INFO_DATA,
  CLEAR_SYS_GUARD_POPUP_DATA,
  DISPLAY_SYS_GUARD_ALERT_COMMENT,
  GET_SYS_GUARD_DISTINCT_LOCATIONS,
  GET_SYS_GUARD_FAILURE_LOCATIONS,
  GET_SYS_GUARD_FAILURE_LOCATIONS_APPLICATION,
  GET_SYS_GUARD_FAILURE_LOCATIONS_USER,
  GET_SYS_GUARD_POPUP_DATA,
  GET_SYS_GUARD_SIDE_POPUP_DATA,
  SET_SYS_GUARD_ALERT_COMMENT,
  sysGuardTableColumnMappings,
} from "../sysGuardConstants";
import UserLocationPopup from "./UserLocationPopup";
import { userApplicationsColumn } from "./SysGuardPopupColumns";
import { useSysGuardDataSource } from "../SysGuardCommonComp";
import { AlertStatusSnackBar } from "../SysGuardHelperComponents";

function ManagePopup({ popupDetails, popupOpen, setPopupOpen }) {
  const { popupData, popupLocation } = popupDetails;
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 });
  const dispatch = useDispatch();
  const countryCityName = useSelector((state) => state.SysGuardReducer.countryName);  
  
  const tableColumns = () => sysGuardTableColumnMappings[popupLocation] || userApplicationsColumn;

  const {
    sysGuardPopupData,
    popupTotalElements,
    loader,
    sidePopupData,
    selectedDatasourceID,
  } = useSelector((state) => state.SysGuardReducer);

  const currentDataSource = useSysGuardDataSource();

  useEffect(() => {
    if (!popupLocation || !popupData || !currentDataSource) return;

    const payload = {
      dataSourceId: popupData.dataSourceId || selectedDatasourceID.join(","),
      actorId: popupData?.userId,
      loc: popupLocation,
      country: popupData?.countryName || countryCityName,
      city: popupData?.cityName,
      application: popupData?.applicationName,
    };

    if (popupLocation === "userLocations") {
      dispatch({ type: GET_SYS_GUARD_DISTINCT_LOCATIONS, payload });
    }

    if (popupLocation === "locationBasedFailurePercentage" || popupLocation === "cityBasedFailurePercentage") {
      dispatch({ type: GET_SYS_GUARD_FAILURE_LOCATIONS, payload });
    }

    if (popupLocation === "userBasedFailurePercentage") {
      dispatch({ type: GET_SYS_GUARD_FAILURE_LOCATIONS_USER, payload });
    }

    if (popupLocation === "applicationBasedFailurePercentage") {
      dispatch({ type: GET_SYS_GUARD_FAILURE_LOCATIONS_APPLICATION, payload });
    }

    dispatch({
      type: GET_SYS_GUARD_POPUP_DATA,
      payload: {
        ...payload,
        currentPage: pagination.page,
        pageSize: pagination.pageSize,
      },
    });

    if (popupLocation !== "locationBasedUsers" && popupLocation !== "cityBasedUsers") {
      dispatch({ type: GET_SYS_GUARD_SIDE_POPUP_DATA, payload });
    }
  }, [popupLocation, popupData, currentDataSource, pagination]);

  return (
    <>
      <UserLocationPopup
        popupOpen={popupOpen}
        popupData={popupData}
        sysGuardPopupData={sysGuardPopupData}
        onClose={() => {
          setPopupOpen(false);
          dispatch({ type: CLEAR_SYS_GUARD_ALERT_INFO_DATA });
          dispatch({ type: CLEAR_SYS_GUARD_POPUP_DATA });
          setPagination({ page: 0, pageSize: 10 });
          dispatch({
            type: DISPLAY_SYS_GUARD_ALERT_COMMENT,
            payload: false,
          });
          dispatch({
            type: SET_SYS_GUARD_ALERT_COMMENT,
            payload: null,
          });
        }}
        totalElements={popupTotalElements}
        pagination={pagination}
        setPagination={setPagination}
        sysGuardTableLoader={loader}
        tableColumns={tableColumns}
        sidePopupData={sidePopupData}
        loc={popupLocation}
        dataSourceId={currentDataSource?.id}
        countryName={countryCityName}
      />
      <AlertStatusSnackBar />
    </>
  );
}

export default ManagePopup;
